import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  // Hospitals
  listHospitals: () => client.get("/hospitals").then((r) => r.data),
  getHospital: (code) => client.get(`/hospitals/${code}`).then((r) => r.data),
  createHospital: (body) => client.post("/hospitals", body).then((r) => r.data),
  updateHospital: (code, body) => client.put(`/hospitals/${code}`, body).then((r) => r.data),
  deleteHospital: (code) => client.delete(`/hospitals/${code}`).then((r) => r.data),

  // Doctors / Patients
  listDoctors: (code) => client.get(`/hospitals/${code}/doctors`).then((r) => r.data),
  listPatients: (code) => client.get(`/hospitals/${code}/patients`).then((r) => r.data),
  createPatient: (code, body) => client.post(`/hospitals/${code}/patients`, body).then((r) => r.data),
  getPatient: (id) => client.get(`/patients/${id}`).then((r) => r.data),
  toggleTask: (patientId, taskId, done) =>
    client.put(`/patients/${patientId}/tasks/${taskId}`, { done }).then((r) => r.data),
  updateTask: (patientId, taskId, updates) =>
    client.put(`/patients/${patientId}/tasks/${taskId}`, updates).then((r) => r.data),
  regeneratePlan: (patientId, specialty, duration = 20) =>
    client.post(`/patients/${patientId}/regenerate-plan`, { specialty, duration }).then((r) => r.data),
  finalizePlan: (patientId) =>
    client.post(`/patients/${patientId}/finalize-plan`).then((r) => r.data),
  unfinalizePlan: (patientId) =>
    client.post(`/patients/${patientId}/unfinalize-plan`).then((r) => r.data),

  // Weekly summaries + nurse workflow
  weeklySummaries: (code) => client.get(`/hospitals/${code}/weekly-summaries`).then((r) => r.data),
  approveWeek: (patientId, week) =>
    client.post(`/patients/${patientId}/approve-week/${week}`).then((r) => r.data),
  toggleNurseAssistance: (patientId, enabled) =>
    client.put(`/patients/${patientId}/nurse-toggle`, { enabled }).then((r) => r.data),
  setNurseCalls: (patientId, days) =>
    client.put(`/patients/${patientId}/nurse-calls`, { days }).then((r) => r.data),
  nurseQueue: (code) => client.get(`/hospitals/${code}/nurse-queue`).then((r) => r.data),
  checkin: (patientId, seconds) =>
    client.post(`/patients/${patientId}/checkin`, { seconds }).then((r) => r.data),

  // Content
  getQuestions: (specialty) => client.get(`/questions/${specialty}`).then((r) => r.data),

  // Voice / AI mocks
  transcribe: () => client.post("/voice/transcribe", {}).then((r) => r.data),
  generatePlan: (specialty) => client.post("/ai/generate-plan", { specialty }).then((r) => r.data),
  triageAnalysis: (patient) => client.post("/ai/triage-analysis", patient).then((r) => r.data),

  stats: () => client.get("/stats").then((r) => r.data),
};
